import { Card, CardContent, Container, Grid } from 'ui';
import { FunctionComponent, useEffect } from 'react';
import { Link, Typography } from 'omakase';
import { Theme, css } from '@emotion/react';
import { getGiftCardBalance } from 'selectors/patronSelectors';
import {
  giftCardBalanceAccountNumber,
  giftCardBalanceAmount,
  giftCardBalanceAmountContent,
  giftCardBalanceBalance,
  giftCardBalanceCard,
  giftCardBalanceContainer,
  giftCardBalanceExploreButton,
  giftCardBalanceHeader,
  giftCardBalanceRoot,
} from 'components/account/giftCardBalanceCssDefs';
import { useSelector } from 'react-redux';
import ConsumerDisplayMoney from 'components/ConsumerDisplayMoney';

export const GiftCardBalance: FunctionComponent<{}> = () => {
  const giftCardBalance = useSelector(getGiftCardBalance);

  useEffect(() => {
    if (window.analytics) {
      window.analytics.gaTrack('ec:addPromo', {
        id: 'TOCK_GIFT_CARD_CTA_BALANCE_PROMO',
        name: 'Tock gift card cta balance promo',
        creative: 'cta card with text',
        position: 'main content',
      });
    }
  }, []);

  return (
    <div css={giftCardBalanceRoot}>
      <div css={giftCardBalanceHeader}>
        <Container maxWidth="sm">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {/* Render the following component for mobile screens */}
              <Typography
                css={({ breakpoints, spacing }: Theme) => css`
                  margin-top: ${spacing(5.25)}px;

                  ${breakpoints.up('sm')} {
                    display: none;
                  }
                `}
                component="h1"
                variant="heading02"
                color="fgDefault"
              >
                Gift cards
              </Typography>
              {/* Render the following component for desktop screens */}
              <Typography
                css={({ breakpoints }: Theme) => css`
                  display: none;

                  ${breakpoints.up('sm')} {
                    display: block;
                  }
                `}
                variant="heading03"
                component="h2"
                mb={2}
              >
                Gift cards
              </Typography>
              <Typography component="span" variant="body02">
                Use your gift card balance on <Link href="/">exploretock.com</Link> at US
                businesses. To use your balance, begin a purchase on Tock and apply the balance
                during checkout.
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </div>
      <Container css={giftCardBalanceContainer} maxWidth="sm">
        <Grid css={giftCardBalanceAmount} container spacing={2}>
          <Grid item xs={12}>
            <Card css={giftCardBalanceCard} variant="outlined">
              <CardContent>
                <div css={giftCardBalanceAmountContent}>
                  <div css={giftCardBalanceBalance}>
                    <Typography variant="body02Strong" component="h3">
                      Current balance
                    </Typography>
                    <Typography variant="decorative" component="h4">
                      <ConsumerDisplayMoney amount={giftCardBalance.data?.balanceCents ?? 0} />
                    </Typography>
                  </div>
                  {giftCardBalance.data?.cardNumber ? (
                    <div css={giftCardBalanceAccountNumber}>
                      <Typography mb={0.5} variant="body02Strong">
                        Gift card account number
                      </Typography>
                      <Typography variant="caption">{giftCardBalance.data.cardNumber}</Typography>
                    </div>
                  ) : null}
                </div>
                <div css={giftCardBalanceExploreButton}>
                  <Link size="medium" href="/">
                    Start exploring Tock
                  </Link>
                </div>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};
